import { createStore as reduxCreateStore } from "redux";

const UPDATE_SEARCH_QUERY = "UPDATE_SEARCH_QUERY";
const TOGGLE_MOBILE_MENU_OPEN = "TOGGLE_MOBILE_MENU_OPEN";
const TOGGLE_SEARCH_INPUT = "TOGGLE_SEARCH_INPUT";
const SET_SHOW_SEARCH_INPUT = "SET_SHOW_SEARCH_INPUT";

const initialState = {
  searchQuery: "",
  showSearchInput: false,
  mobileMenu: {
    open: false,
    hasBeenOpened: false
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_QUERY:
      return {
        ...state,
        searchQuery: action.payload
      };
    case TOGGLE_MOBILE_MENU_OPEN:
      return {
        ...state,
        mobileMenu: {
          open: !state.mobileMenu.open,
          hasBeenOpened: true
        }
      };
    case TOGGLE_SEARCH_INPUT:
      return {
        ...state,
        showSearchInput: !state.showSearchInput
      };
    case SET_SHOW_SEARCH_INPUT:
      return {
        ...state,
        showSearchInput: action.payload
      };
    default:
      return state;
  }
};

export function updateSearchQuery(query) {
  return {
    type: UPDATE_SEARCH_QUERY,
    payload: query
  };
}

export function toggleSearchInput() {
  return {
    type: TOGGLE_SEARCH_INPUT
  };
}

export function setShowSearchInput(show) {
  return {
    type: SET_SHOW_SEARCH_INPUT,
    payload: show
  };
}

export function toggleMobileMenuOpen() {
  return {
    type: TOGGLE_MOBILE_MENU_OPEN
  };
}

const createStore = () =>
  reduxCreateStore(
    reducer,
    initialState,
    /* eslint no-underscore-dangle: off  */
    typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f
  );

export default createStore;



// WEBPACK FOOTER //
// ./src/state/index.js